export enum Key {
    FAQKey = '360003372918',

}
export enum API {
    endpoint = 'https://albums.zendesk.com/api/v2/help_center',
}
